/* eslint-disable no-unused-vars */
import { CancelTokenSource } from 'axios';
import { getStorageValue } from 'src/hooks/useLocalStorage';
import { IW2Form } from 'src/interfaces';
import http from './http';

class PaymentsService {
  static getAllPayStubPdf(startDate: string, endDate: string) {
    return `${
      process.env.REACT_APP_API_URL
    }payments/generate-all-pdfs?startDate=${startDate}&endDate=${endDate}&token=${getStorageValue(
      'accessToken',
      null
    )}`;
  }

  static getPaystubsRange() {
    return http.get('/payments/paystubs/range');
  }

  static getPaymentsSummary() {
    return http.get('/payments/summary');
  }

  static getPayStubs(startDate: string, endDate: string) {
    return http.get(`/payments?startDate=${startDate}&endDate=${endDate}`);
  }

  static getLatestPayStubs() {
    return `${process.env.REACT_APP_API_URL}payments/generate-last-paystub-pdf?token=${getStorageValue(
      'accessToken',
      null
    )}&download=true`;
  }

  static getPayStubPdf(ptn: string, downloadFile = false) {
    return `${
      process.env.REACT_APP_API_URL
    }payments/generate-pdf?download=${downloadFile}&ptn=${ptn}&token=${getStorageValue('accessToken', null)}`;
  }

  static getCountPaystubs(source?: CancelTokenSource) {
    if (source?.token) {
      return http.get('/payments/paystubs', {
        cancelToken: source.token,
      });
    }
    return http.get('/payments/paystubs');
  }

  static getW2List(): Promise<IW2Form[]> {
    return http.get('/tax-forms').then(data => data.data);
  }

  static getW2FormPdf(
    controlNumber: string,
    year: string,
    identificationNumber: string,
    employeeId: string,
    downloadFile = false
  ) {
    return `${
      process.env.REACT_APP_API_URL
    }tax-forms/generate-pdf?download=${downloadFile}&controlNumber=${controlNumber}&year=${year}&identificationNumber=${identificationNumber}&employeeId=${employeeId}&token=${getStorageValue(
      'accessToken',
      null
    )}`;
  }

  static getHealthFormPdf(
    controlNumber: string,
    year: string,
    identificationNumber: string,
    employeeId: string,
    downloadFile = false
  ) {
    return `${
      process.env.REACT_APP_API_URL
    }tax-forms/generate-health-pdf?download=${downloadFile}&controlNumber=${controlNumber}&year=${year}&identificationNumber=${identificationNumber}&employeeId=${employeeId}&token=${getStorageValue(
      'accessToken',
      null
    )}`;
  }

  static postDistributionMethod(method: string) {
    return http.post(`/tax-forms/distribution?method=${method}`);
  }

  static getDistributionMethod() {
    return http.get('/tax-forms/distribution/employee');
  }

  static getPaymentsSummaryByYear(year: string) {
    const startDate = `${year}-01-01`;
    const endDate = `${year}-12-31`;
    return http.get(`/payments/summary?startDate=${startDate}&endDate=${endDate}`);
  }

  static getPaystubsByYear(year: any) {
    const startDate = `${year - 3}-01-01`;
    const endDateYear = year;
    return http.get(`/payments/paystubs/range?startDate=${startDate}&endDate=${endDateYear}-12-31`);
  }
}

export default PaymentsService;
